module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/main-view@2x_82239f0934241a56ce1f52f530f882cf.png";